
import { Component, Prop, Vue } from 'vue-property-decorator';
import List from '../components/ListPc.vue';
import { DownloadUrls, So360DownloadCallbackData } from '../config/types';

@Component({
  components: { List },
})
export default class PcGameListSection extends Vue {
  @Prop({ required: true }) public downloadUrls!: DownloadUrls;
  @Prop({ default: '' }) public baiduApiToken!: string;
  @Prop() public so360DownloadConfig?: So360DownloadCallbackData;
  @Prop({ default: false }) public byDownloadConfig!: boolean;
  @Prop({ default: false }) public collectEnabled!: boolean;
}
